import { useMediaQuery } from "@mui/material";
import { useState } from "react";
import axios from "../../../lib/axios";
import { ADMIN_ORDER_UPDATE, ADMIN_ORDER_UPDATE_STATUS } from "../../../lib/endpoints/order";
import { OrderModel } from "../../../models/order";
import { convertOrderStatusEnumToStatusCode } from "../../../utils/convertOrderStatusValue";
import { OrderStatusEnum } from "../../../enums/orderStatus";

interface Props {
  selectedData: OrderModel;
  onClose: VoidFunction;
  onRefetchData: () => Promise<void>;
}

const useOrderDetailController = ({
  selectedData,
  onClose,
  onRefetchData,
}: Props) => {
  // variables

  const isSmallScreen = useMediaQuery((theme: any) =>
    theme.breakpoints.down("sm")
  );
  const [openConfirmDialog, setOpenConfirmDialog] = useState<boolean>(false);
  const [isDeclineOrder, setIsDeclineOrder] = useState<boolean>(false);
  const [loadingConfirmDialog, setLoadingConfirmDialog] =
    useState<boolean>(false);
  const [isPacking, setIsPacking] = useState<boolean>(false);

  const [openConfirmDeclineDialog, setOpenConfirmDeclineDialog] =
    useState<boolean>(false);
  const [loadingConfirmDeclineDialog, setLoadingConfirmDeclineDialog] =
    useState<boolean>(false);
  // functions

  const handleOpenIsPacking = () => {
    setIsPacking(true);
  };

  const handleCloseIsPacking = () => {
    setIsPacking(false);
  };

  const handleOpenConfirmDialog = (getIsDeclineOrder: boolean) => {
    setOpenConfirmDialog(true);
    setIsDeclineOrder(getIsDeclineOrder);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleOpenDeclineConfirmDialog = () => {
    setOpenConfirmDeclineDialog(true);
  };

  const handleCloseDeclineConfirmDialog = () => {
    setOpenConfirmDeclineDialog(false);
  };

  const handleDeclineConfirmDialog = async (getDescription: string) => {
    try {
      setLoadingConfirmDeclineDialog(true);
      const inputOrderStatus: number = convertOrderStatusEnumToStatusCode(
        OrderStatusEnum.Failed
      );
      await axios.post(
        `${ADMIN_ORDER_UPDATE}?id=${selectedData?.id}&status=${inputOrderStatus}`,
        {
          description: getDescription,
          carts: selectedData?.carts?.map((item) => {
            return {
              productId: item?.product?.id,
              quantity: item?.quantity,
            };
          }),
          
        }
      );
      await onRefetchData();
      onClose();
    } catch (err) {
      window.alert("server error please try again");
    } finally {
      setLoadingConfirmDeclineDialog(false);
    }
  };

  const handleAcceptOrder = async () => {
    try {
      setLoadingConfirmDialog(true);
      const inputOrderStatus: number = isDeclineOrder
        ? convertOrderStatusEnumToStatusCode(OrderStatusEnum.Failed)
        : convertOrderStatusEnumToStatusCode(OrderStatusEnum.To_Pack);
        console.log( `${ADMIN_ORDER_UPDATE_STATUS}?orderId=${selectedData?.id}&status=${inputOrderStatus}`);
      await axios.post(
        `${ADMIN_ORDER_UPDATE_STATUS}?orderId=${selectedData?.id}&status=${inputOrderStatus}`
      );
      await onRefetchData();

      onClose();
    } catch (err) {
      console.log('error=',err);
      window.alert("server error please try again");
    } finally {
      setLoadingConfirmDialog(false);
    }
  };

  return {
    isSmallScreen,
    openConfirmDialog,
    loadingConfirmDialog,
    handleCloseConfirmDialog,
    handleAcceptOrder,
    handleOpenConfirmDialog,
    isDeclineOrder,
    isPacking,
    handleOpenIsPacking,
    handleCloseIsPacking,
    openConfirmDeclineDialog,
    loadingConfirmDeclineDialog,
    handleOpenDeclineConfirmDialog,
    handleCloseDeclineConfirmDialog,
    handleDeclineConfirmDialog,
  };
};
export default useOrderDetailController;
